export const SET_COMMON_WIDTH = 'SET_COMMON_WIDTH';
export const SET_LOGIN_PATH = 'SET_LOGIN_PATH';
export const SET_VERSION = 'SET_VERSION';

export function setCommonWidth(width) {
  return {
    type: SET_COMMON_WIDTH,
    width,
  };
}

export function setLoginPath(value) {
  return {
    type: SET_LOGIN_PATH,
    value,
  };
}

export function setVersion(version) {
  return {
    type: SET_VERSION,
    version,
  };
}



// WEBPACK FOOTER //
// ./app/actions/AppActionCreators.js